import { Component, Inject } from '@angular/core';
import { SavedList } from '../../saved-lists/saved-lists.service';
import { CompanyInfoService } from '../../company-search/company-info-service.service';

@Component({
    selector: 'app-saved-list-item-renderer',
    templateUrl: './saved-list-item-renderer.component.html',
    styleUrls: ['./saved-list-item-renderer.component.scss'],
    standalone: false
})
export class SavedListItemRendererComponent {
  item: SavedList;
  allowDelete: boolean;
  private onItemSelected: (item: SavedList) => void;
  private onItemDeleted: (item: SavedList) => void;

  isExpanded: boolean = false;
  companyNames: { [key: string]: string } = {};

  constructor(
    @Inject('item') item: SavedList,
    @Inject('allowDelete') allowDelete: boolean,
    @Inject('showCreator') public showCreator: boolean,
    @Inject('onItemSelected') onItemSelected: (item: SavedList) => void,
    @Inject('onItemDeleted') onItemDeleted: (item: SavedList) => void,
    private companyInfoService: CompanyInfoService
  ) {
    this.item = item;
    this.allowDelete = allowDelete;
    this.onItemSelected = onItemSelected;
    this.onItemDeleted = onItemDeleted;
  }

  selectItem() {
    if (this.item) {
      this.onItemSelected(this.item);
    }
  }

  deleteItem(event: Event) {
    event.stopPropagation();
    if (this.item) {
      this.onItemDeleted(this.item);
    }
  }

  toggleExpansion(event: Event) {
    event.stopPropagation();
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded && this.item?.items && Object.keys(this.companyNames).length === 0) {
      this.loadCompanyNames();
    }
  }

  loadCompanyNames() {
    if (!this.item?.items || this.item.items.length === 0) return;

    const companyIds = this.item.items
      .filter((company) => company.id && !company.name)
      .map((company) => company.id);

    if (companyIds.length === 0) {
      // If all companies already have names, use them
      this.item.items.forEach((company) => {
        if (company.name) {
          this.companyNames[company.id] = company.name;
        }
      });
      return;
    }

    // Load company names from service
    companyIds.forEach((id) => {
      this.companyInfoService.getCompanyInfo(id).subscribe({
        next: (info) => {
          if (info?.name) {
            this.companyNames[id] = info.name;
          }
        },
        error: () => {
          this.companyNames[id] = id; // Fallback to ID if loading fails
        },
      });
    });
  }

  getCompanyName(companyId: string): string {
    // First check if the company item has a name
    const company = this.item?.items?.find((c) => c.id === companyId);
    if (company?.name) {
      return company.name;
    }

    // Otherwise check our loaded names
    return this.companyNames[companyId] || 'Loading...';
  }
}
